import { Link } from "../models"

export const TicketDesignTypes =  {
	TICKET_PRINT: "TICKET_PRINT",
	PRINT_AT_HOME: "PRINT_AT_HOME"
}

export interface TicketDesign {
	content: string,
	_links: {
		preview_base64_png: Link
	}
}


// WEBPACK FOOTER //
// ./src/app/models/ticket-design.model.ts